// extracted by mini-css-extract-plugin
module.exports = {"deactivationModal":"DeactivationModal_deactivationModal__3o5Rn"};